import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ApteneoZakupyPage = lazy(() =>
	import("@/features/apteneo/zakupy-page").then((m) => ({
		default: m.ApteneoZakupyPage,
	})),
);

// Okres deep-linkowalny; `.catch()` na kazdym polu — zly param ze starej zakladki
// nie moze wywalic trasy ZodErrorem (FARMASTER-FRONTEND-31/33/34).
const searchSchema = z.object({
	rok: z.number().int().min(2000).max(2100).optional().catch(undefined),
	kwartal: z.number().int().min(1).max(4).optional().catch(undefined),
});

export type ApteneoZakupySearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/apteneo/zakupy")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.apteneo.zakupy", location.pathname);
	},
	component: ApteneoZakupyPage,
	validateSearch: (search: Record<string, unknown>): ApteneoZakupySearch =>
		searchSchema.parse(search),
});
